import { useState, useEffect } from "react";
import config from "../config/config";

const useRegulatoryBody = (country) => {
    const [regulatoryBodies, setRegulatoryBodies] = useState([]);

    useEffect(()=>{
        const fetchRegulatoryBody = async () => {
            try {
                const token = localStorage.getItem("token"); // Retrieve token from localStorage
                const response = await fetch(`${config["backend-url"]}/regulatory_bodies`, {
                    method: "POST",
                    headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ country: country }),
                });
      
                const data = await response.json();

                if (response.ok) {
                    setRegulatoryBodies(data);
                  } else if (response.status === 404 && data.message) {
                    console.warn(`⚠️ ${data.message}`);
                  } else {
                    console.error("❌ Failed to fetch regulatory bodies:", data);
                    throw new Error(data.message || "Failed to fetch regulatory bodies");
                  }
            } catch (error) {
                console.error("❌ Error during API call:", error);
            }
        }

        if (country) fetchRegulatoryBody(country);

    },[country]);

    return regulatoryBodies;
}

export default useRegulatoryBody;